var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTheft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15671_13431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9356 12.3383L22.7182 4.95878C22.5198 4.29746 21.8469 3.89289 21.1699 4.02516L15.8055 5.07937L10.4449 4.02516C9.76807 3.89289 9.09507 4.29357 8.89667 4.95878L6.66375 12.3967C2.62971 13.0152 0 14.0227 0 15.1587C0 17.0375 7.1656 18.5625 16 18.5625C24.8383 18.5625 32 17.0375 32 15.1587C32 13.9838 29.1991 12.9491 24.9356 12.3383Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9354 12.3383L22.718 4.95878C22.5196 4.29746 21.8467 3.89289 21.1697 4.02516L15.8054 5.07937L10.4448 4.02516C9.76789 3.89289 9.09489 4.29357 8.89649 4.95878L6.66357 12.3967C6.66373 14.7098 25.5241 15.2238 24.9354 12.3383Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5307 20.8509C26.1106 20.3257 25.4609 20.0611 24.7918 20.1467C18.6805 20.917 12.643 20.9209 6.83896 20.1545C6.166 20.0651 5.51635 20.3257 5.09233 20.8547C4.6722 21.3799 4.5555 22.0723 4.7889 22.7025L4.89782 23.0021C5.6136 24.9666 7.2319 26.5109 9.22363 27.1373L9.70603 27.289C11.4138 27.8258 13.2732 27.3823 14.557 26.1336C15.2572 25.4529 16.3581 25.4529 17.0583 26.1336C17.9802 27.0322 19.2018 27.5146 20.4505 27.5146C20.9368 27.5146 21.4308 27.4407 21.9092 27.289L22.3916 27.1373C24.3872 26.5109 26.0056 24.9666 26.7174 23.0021L26.8302 22.6987C27.0598 22.0685 26.9508 21.376 26.5307 20.8509ZM10.5774 24.8927C9.1925 24.6476 8.15776 23.9435 8.27056 23.3172C8.3795 22.6909 9.59316 22.3835 10.978 22.6286C12.363 22.8737 13.3977 23.5778 13.2849 24.2041C13.176 24.8265 11.9622 25.1377 10.5774 24.8927ZM21.0418 24.8927C19.6569 25.1377 18.4432 24.8265 18.3342 24.2041C18.2253 23.5778 19.2562 22.8737 20.6411 22.6286C22.026 22.3835 23.2397 22.6947 23.3486 23.3172C23.4614 23.9435 22.4266 24.6476 21.0418 24.8927Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15671_13431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white",
    transform: "translate(0 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheft);
export default __webpack_public_path__ + "static/media/theft.fa136b830fb30bf9d2a52f07ffc9522f.svg";
export { ForwardRef as ReactComponent };